"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/grid/style/index.js
// module id = 385
// module chunks = 1